import {
    generateOidcAccessToken,
    generateOidcAuthenticationRequest,
    handleFirstPage,
    handleHandover,
    handleRedirectionFromFedLoginOrSales,
    handleStateParam,
    isFirstPageInGeorge,
    isHandoverWithOidc,
    isRedirectFromFedLoginOrSales,
    isRedirectFromOidcLogin,
} from '@retail/auth';
import { isOpenIdConnectEnabled } from '@shared/environment';
import { logger } from '@luna/logger';

export async function handleLoginRedirects(): Promise<void> {
    if (isRedirectFromFedLoginOrSales()) {
        // We are already logged in
        handleRedirectionFromFedLoginOrSales();
        return;
    }
    if (isHandoverWithOidc()) {
        // We have OIDC enabled and state params includes handover
        handleHandover();
        return;
    }
    if (isRedirectFromOidcLogin()) {
        // We are not logged in, but we're redirected from OIDC login
        await generateOidcAccessToken();
        return;
    }
    if (isOpenIdConnectEnabled()) {
        // We are not logged in, but detect OIDC is enabled
        await generateOidcAuthenticationRequest();
        return;
    }
    if (isFirstPageInGeorge()) {
        // We are not logged in yet
        handleFirstPage();
    } else {
        // We are logged in
        handleStateParam();
    }
}

// redirect from OIDC login means we should continue loading main page
// as we generate locally the tokens
export const shouldLoadMainPage = (): boolean => {
    if (isRedirectFromOidcLogin()) {
        logger.debug('Redirect from OIDC login detected');
        return true;
    }

    if (isRedirectFromFedLoginOrSales()) {
        logger.debug('Redirect from FED or Sales detected');
        return false;
    }

    if (isFirstPageInGeorge()) {
        logger.debug('First page in George detected - wont render yet');
        return false;
    }

    return true;
};

const CLICKJACKING_ERROR = 'Loading George in iFrame is not allowed';

function trackFrameBust() {
    const request = new XMLHttpRequest();
    request.open('GET', 'frame_bust_tracking.html', false);
    request.send(null);
}

export function checkAntiClickJack() {
    // eslint-disable-next-line no-restricted-globals
    if (top && self !== top && self.location.hostname !== 'localhost') {
        trackFrameBust();
        alert(CLICKJACKING_ERROR);
        // eslint-disable-next-line no-restricted-globals
        (top.location as Location) = self.location;
        throw new Error(CLICKJACKING_ERROR);
    }
    const antiClickJack = document.getElementById('antiClickJack');
    antiClickJack!.parentNode!.removeChild(antiClickJack!);
}
